var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _class, _class2, _descriptor, _descriptor2;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/**
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, Watch } from '@sick-davinci/ce-decorators';
import { style } from './BarChartSingle.style';
import { CssTools } from '../../_utils/CssTools.js';
import { resolveCssColor, toCssColorValue } from '../../_utils/ColorTools.js';
import { AbstractBarChartGrouped } from '../bar-chart-grouped/AbstractBarChartGrouped.js';
import { BarChartSingleLayout } from './BarChartSingleLayout.js';
import { createValueFormat } from '../../_utils/ValueFormat.js';
import { createBalloonTooltipStyle } from '../../_utils/TooltipTools.js';
/**
 * A simple bar chart with single bars.
 * This chart supports logarithmic value ranges.
 *
 * @example
 * ```html
 * <davinci-element-container heading="BarChartSingle" style="width: 400px; height: 300px">
 *   <davinci-bar-chart-single values="[4,5,6]" bar-labels='["A", "B", "C"]' colors="[0, 1, 2]" legend-labels='["one", "two", "three"]'></davinci-bar-chart-single>
 * </davinci-element-container>
 * ```
 */

export let BarChartSingle = (_dec = Component({
  tag: 'davinci-bar-chart-single',
  style
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", Boolean), _dec5 = Watch('noTooltip'), _dec6 = Reflect.metadata("design:paramtypes", []), _dec7 = Prop({
  reflectAsAttribute: false
}), _dec8 = Reflect.metadata("design:type", Object), _dec9 = Prop({
  reflectAsAttribute: false
}), _dec10 = Reflect.metadata("design:type", Object), _dec11 = Prop({
  reflectAsAttribute: false
}), _dec12 = Reflect.metadata("design:type", Object), _dec13 = Prop({
  reflectAsAttribute: false
}), _dec14 = Reflect.metadata("design:type", Object), _dec15 = Prop(), _dec16 = Reflect.metadata("design:type", Boolean), _dec17 = Watch('barValues'), _dec18 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = (_class2 = class BarChartSingle extends AbstractBarChartGrouped {
  constructor() {
    super([0]); // default is the first color of the selected palette for all bars

    _initializerDefineProperty(this, "noTooltip", _descriptor, this);

    _initializerDefineProperty(this, "barValues", _descriptor2, this);
  }
  /**
   * Whether tooltips are disabled.
   *
   * @default false (tooltips are enabled by default)
   */


  noTooltipWatcher() {
    this._update();
  }
  /**
   * The labels to be used for the bars (one label per bar).
   *
   * @default []
   */


  get barLabels() {
    return this._getCategoryLabels();
  }

  set barLabels(labels) {
    this._setCategoryLabels(labels);
  }
  /**
   * The icons to be used for the bars (one icon per bar).
   *
   * @default []
   */


  get icons() {
    return this._getCategoryIcons();
  }

  set icons(icons) {
    this._setCategoryIcons(icons);
  }
  /**
   * The values to be used for the bars.
   *
   * @default []
   */


  get values() {
    // convert the 2-dimensional array of the parent class to a 1-dimensional array
    const values1d = [];

    this._getValues().forEach(values => values1d.push(...values));

    return values1d;
  }

  set values(values) {
    // convert the 1-dimensional array to a 2-dimensional array passed to the parent class
    const values2d = [];
    values.forEach(value => values2d.push([value]));

    this._setValues(values2d);
  }
  /**
   * The colors to be used for the bars.
   * The first element denotes the color for the first bar,
   * the second element denotes the color for the second bar and so on.
   *
   * Each entry of this array is either interpreted as an index referring to the selected palette, or a css-color-value designation (e.g. 'purple', '#ff00ff', 'rgba(255,255,128,0.5)')
   *
   * If there are more bars than colors the array will be traversed from the beginning
   *
   * @default [0] - use the first color of the current color-palette for all bars.
   */


  get colors() {
    return this._getSeriesColors();
  }

  set colors(value) {
    this._setSeriesColors(value);
  }
  /**
   * Whether to show the value of a bar.
   *
   * @default false - do not show the bar value
   */


  barValuesWatcher() {
    this._update();
  }
  /**
   * @override
   */


  _createStyle(hostFontFamily) {
    const style = super._createStyle(hostFontFamily);

    style.barColors = this._computeBarColors();
    style.barSize = CssTools.REM2PIXEL(BarChartSingleLayout.BAR_SIZE);
    style.barGap = CssTools.REM2PIXEL(BarChartSingleLayout.BAR_GAP);
    style.minGapBetweenGroups = this.horizontal ? CssTools.REM2PIXEL(BarChartSingleLayout.MIN_BAR_DISTANCE_HORIZONTAL) : CssTools.REM2PIXEL(BarChartSingleLayout.MIN_BAR_DISTANCE_VERTICAL);
    style.maxGapBetweenGroups = CssTools.REM2PIXEL(BarChartSingleLayout.MAX_BAR_DISTANCE);
    style.showTooltip = !this.noTooltip;

    if (style.showTooltip) {
      style.tooltipStyle = createBalloonTooltipStyle(hostFontFamily, this.shorthandLabels, this.decimalPlaces);
      style.activeGroupBackgroundColor = resolveCssColor('var(--davinci-color-background-elements-overlay-2)');
    }

    const valueLabelFormat = createValueFormat(this.shorthandLabels, this.decimalPlaces);
    style.valueLabelsStyle = {
      showValueLabels: this.barValues,
      valueLabelGapHorizontal: 2.0,
      // minimal distance to keep the labels separate from grid lines
      valueLabelGapVertical: CssTools.REM2PIXEL(BarChartSingleLayout.VALUE_LABEL_GAP),
      valueLabelFormat: {
        format(value, locale) {
          return valueLabelFormat(value, locale);
        }

      },
      valueLabelFont: {
        family: hostFontFamily,
        size: CssTools.REM2PIXEL(BarChartSingleLayout.VALUE_LABEL_FONT_SIZE),
        style: 'normal',
        weight: 600 // semi-bold

      }
    };
    return style;
  }
  /**
   * Computes the bar colors.
   *
   * The first dimension denotes the group, the second dimension the bar.
   *
   * @returns the colors to be used for the bars
   */


  _computeBarColors() {
    return this._getSeriesColors().map(color => [toCssColorValue(color, this.palette)]);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "noTooltip", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "noTooltipWatcher", [_dec5, _dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "noTooltipWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "barLabels", [_dec7, _dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "barLabels"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_dec9, _dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "values", [_dec11, _dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "values"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "colors", [_dec13, _dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "colors"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "barValues", [_dec15, _dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "barValuesWatcher", [_dec17, _dec18], Object.getOwnPropertyDescriptor(_class2.prototype, "barValuesWatcher"), _class2.prototype)), _class2)) || _class) || _class);
